import React from "react";
import RegionTitle from "../../State/StateAccordion/Regions/RegionTitle";
import NicheItemsTitle from "../../State/StateAccordion/NicheItems/NicheItemsTitle";
import ListingsTitle from "../../State/StateAccordion/Listings/ListingsTitle";
import { Spinner } from "reactstrap";
import SectionWrapper from "./SelectionWrapper";
import NicheAreasTitle from "../../Niche/NicheAreasTitle";
import { useSelectionContext } from "./hooks/useSelectionContext";

const SelectionContext = ({ stateId, nicheItemId, agentId, ...props }) => {
    const {
        setMapView,
        pageType,
        stateData,
        nicheData,
        childNicheItems,
        listingsPreview,
        agentListings,
        isFetchingGis,
        hasSearched,
        hasRegions,
        nichetypePlural,
        selection,
    } = useSelectionContext({ stateId, nicheItemId, agentId });

    return (
        <div {...props}>
            <div className="d-flex">
                {pageType !== "states" ? (
                    <>
                        {childNicheItems && (
                            <SectionWrapper
                                collapsed={selection !== "areas"}
                                onClick={() => setMapView("areas")}
                            >
                                <NicheItemsTitle data={nicheData} />
                            </SectionWrapper>
                        )}
                        <SectionWrapper
                            collapsed={selection === "areas"}
                            onClick={() => setMapView("listings")}
                        >
                            <>
                                {isFetchingGis ? (
                                    <div className="d-flex align-items-center">
                                        <Spinner
                                            size="sm"
                                            color="primary"
                                            className="me-2"
                                        />{" "}
                                        Loading listings...
                                    </div>
                                ) : (
                                    <>
                                        <ListingsTitle
                                            initialData={
                                                agentListings || listingsPreview
                                            }
                                            pageType={pageType}
                                        />
                                    </>
                                )}
                            </>
                        </SectionWrapper>
                    </>
                ) : (
                    <>
                        <SectionWrapper
                            collapsed={selection !== nichetypePlural}
                            onClick={() => setMapView(nichetypePlural)}
                        >
                            <NicheItemsTitle data={stateData} />
                        </SectionWrapper>
                        {hasRegions && !hasSearched && (
                            <SectionWrapper
                                collapsed={selection !== "regions"}
                                onClick={() => setMapView("regions")}
                            >
                                <RegionTitle />
                            </SectionWrapper>
                        )}
                        {hasSearched && (
                            <SectionWrapper
                                collapsed={selection !== "listings"}
                                onClick={() => setMapView("listings")}
                            >
                                <>
                                    {isFetchingGis ? (
                                        <>
                                            <Spinner
                                                size="sm"
                                                color="primary"
                                                className="me-2"
                                            />{" "}
                                            Loading listings...
                                        </>
                                    ) : (
                                        <ListingsTitle />
                                    )}
                                </>
                            </SectionWrapper>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default SelectionContext;
